<template>
  <header
    v-if="!Edicao"
    class="sticky top-0 z-50 bg-white dark:bg-slate-900 border-b border-gray-200 dark:border-slate-700 shadow-sm"
  >
    <div class="flex items-center justify-between px-6 py-4">
      <!-- Logo -->
      <div class="h-8">
        <img
          v-if="
            nomeEmpresa == 'BRITECH' ||
            nomeEmpresa == 'DNWAYS_DEMO_Y' ||
            nomeEmpresa == 'DNWAYS_DEMO_X' ||
            nomeEmpresa == 'DNWAYS'
          "
          src="@/assets/logoHeader.png"
          class="h-8 w-auto dark:brightness-200"
          :alt="nomeEmpresa"
        />
        <img
          v-else-if="nomeEmpresa == 'Vortex'"
          src="@/assets/dnways.png"
          class="h-8 w-auto dark:brightness-200"
          :alt="nomeEmpresa"
        />
        <img
          v-else-if="nomeEmpresa == 'ACTUAL'"
          src="@/assets/logoActual_v2.png"
          class="h-8 w-auto dark:logo-invert-dark"
          :alt="nomeEmpresa"
        />
        <img
          v-else-if="nomeEmpresa == 'GENIAL'"
          src="@/assets/logogenial.png"
          class="h-8 w-auto"
          :style="{ filter: !isDark ? 'none' : 'brightness(0) invert(1)' }"
          :alt="nomeEmpresa"
        />
        <img
          v-else-if="nomeEmpresa == 'RJI'"
          src="@/assets/logo/rji.png"
          class="h-12 w-auto dark:brightness-200"
          :style="{ filter: !isDark ? 'invert(1)' : 'brightness(0) invert(1)' }"
          :alt="nomeEmpresa"
        />
        <img
          v-else-if="nomeEmpresa == 'Lastro'"
          src="@/assets/logoLastro.jpg"
          class="h-8 w-auto dark:brightness-200"
          :alt="nomeEmpresa"
        />

        <img
          v-else-if="nomeEmpresa == 'OSLO'"
          src="@/assets/logo/oslo.svg"
          class="h-8 w-auto dark:brightness-200"
          :style="{ filter: !isDark ? 'none' : 'brightness(0) invert(1)' }"
          :alt="nomeEmpresa"
        />
      </div>

      <!-- Navigation buttons -->
      <div class="hidden lg:flex items-center gap-3">
        <!-- Dark mode toggle -->
        <button
          @click="toggleTheme"
          class="p-2 text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-slate-800 rounded-lg transition-colors"
          aria-label="Toggle dark mode"
        >
          <svg
            v-if="!isDark"
            class="w-5 h-5 text-yellow-500"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
            />
          </svg>
          <svg
            v-else
            class="w-5 h-5 text-slate-300"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path
              d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"
            />
          </svg>
        </button>

        <!-- Alterar senha -->
        <button
          v-if="configuracaoToken != 'S'"
          @click="alterarSenha()"
          class="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-slate-800 border border-gray-300 dark:border-slate-600 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-700 transition-colors"
        >
          Alterar senha
        </button>

        <!-- Logoff -->
        <button
          @click="logoff"
          class="px-4 py-2 text-sm font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors"
        >
          Logoff
        </button>
      </div>
    </div>
  </header>

  <!-- Overlay Mobile -->
  <Transition name="fade">
    <div
      v-if="menuAberto && !Edicao"
      @click="menuAberto = false"
      class="fixed inset-0 bg-black/50 dark:bg-black/70 z-40 lg:hidden"
    ></div>
  </Transition>

  <!-- Sidebar Mobile -->
  <Transition name="slide">
    <div
      v-if="menuAberto && !Edicao"
      class="fixed top-0 left-0 h-full w-80 bg-white dark:bg-slate-900 shadow-2xl z-50 overflow-y-auto lg:hidden"
    >
      <!-- Header -->
      <div
        class="flex items-center justify-between p-6 border-b border-gray-200 dark:border-slate-700"
      >
        <h3 class="text-lg font-semibold text-gray-900 dark:text-gray-100">
          Cadastro Pessoa Jurídica
        </h3>
        <button
          @click="menuAberto = false"
          class="p-2 text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200 hover:bg-gray-100 dark:hover:bg-slate-800 rounded-lg transition-colors"
        >
          <svg
            class="w-6 h-6"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
      </div>

      <!-- Menu items -->
      <nav class="p-4">
        <ul class="space-y-2">
          <li v-for="(item, index) in menuItems" :key="index">
            <a
              href="javascript:;"
              @click="selectTab(index)"
              :class="[
                'flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium transition-colors',
                tab === menuIndexToTab(index)
                  ? 'bg-primary text-white dark:bg-blue-600'
                  : 'text-gray-700 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-800',
                tab > menuIndexToTab(index) &&
                  'text-green-600 dark:text-green-400',
              ]"
            >
              <!-- Checkmark se preenchido -->
              <svg
                v-if="tab > menuIndexToTab(index)"
                class="w-5 h-5 flex-shrink-0"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
                />
              </svg>
              <span>{{ item }}</span>
            </a>
          </li>

          <!-- Logout -->
          <li class="pt-4 border-t border-gray-200 dark:border-slate-700">
            <a
              href="javascript:;"
              @click="logoff"
              class="flex items-center gap-3 px-4 py-3 rounded-lg text-sm font-medium text-red-600 dark:text-red-400 hover:bg-red-50 dark:hover:bg-red-900/20 transition-colors"
            >
              <svg
                class="w-5 h-5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"
                />
              </svg>
              Sair
            </a>
          </li>
        </ul>
      </nav>
    </div>
  </Transition>

  <!-- Mobile Toggle Button -->
  <div
    v-if="!Edicao"
    class="lg:hidden sticky top-0 z-30 bg-white dark:bg-slate-900 border-b border-gray-200 dark:border-slate-700 px-4 py-3"
  >
    <div class="flex items-center justify-between">
      <button
        @click="menuAberto = !menuAberto"
        class="p-2 text-gray-600 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-slate-800 rounded-lg transition-colors"
      >
        <svg
          class="w-6 h-6"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="2"
            d="M4 6h16M4 12h16M4 18h16"
          />
        </svg>
      </button>
      <span class="text-sm font-medium text-gray-700 dark:text-gray-300">
        {{ nomeMenu }}
      </span>

      <!-- Dark mode toggle mobile -->
      <button
        @click="toggleTheme"
        class="p-2 text-gray-500 dark:text-gray-400 hover:bg-gray-100 dark:hover:bg-slate-800 rounded-lg transition-colors"
      >
        <svg
          v-if="!isDark"
          class="w-5 h-5 text-yellow-500"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
          />
        </svg>
        <svg
          v-else
          class="w-5 h-5 text-slate-300"
          fill="currentColor"
          viewBox="0 0 20 20"
        >
          <path
            d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"
          />
        </svg>
      </button>
    </div>
  </div>

  <!-- Container Principal -->
  <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
    <!-- Título -->
    <div v-if="!Edicao" class="mb-6">
      <h2 class="text-3xl font-bold text-gray-900 dark:text-gray-100">
        Cadastro
      </h2>
    </div>

    <!-- Navegação Wizard Desktop - Stepper Moderno -->
    <div v-if="!Edicao" class="hidden lg:block mb-8">
      <div class="relative">
        <div class="flex items-start justify-between">
          <div
            v-for="(item, index) in menuItems"
            :key="index"
            class="flex flex-col items-center flex-1 relative"
            :class="{
              'cursor-pointer': index <= maxTabMenuIndex,
              'cursor-not-allowed': index > maxTabMenuIndex,
            }"
            @click="index <= maxTabMenuIndex && selectTab(index)"
          >
            <!-- Linha conectora -->
            <div
              v-if="index < menuItems.length - 1"
              class="absolute top-5 left-1/2 w-full h-0.5 -z-10"
              :class="[
                menuIndexToTab(index) < tab
                  ? 'bg-green-500 dark:bg-green-400'
                  : 'bg-gray-200 dark:bg-slate-700',
              ]"
            ></div>

            <!-- Círculo com número/check -->
            <div
              class="flex items-center justify-center w-10 h-10 rounded-full border-2 mb-2 transition-all duration-200"
              :class="[
                tab === menuIndexToTab(index)
                  ? 'bg-primary border-primary text-white dark:bg-blue-600 dark:border-blue-600 scale-110 shadow-lg'
                  : menuIndexToTab(index) < tab
                  ? 'bg-green-500 border-green-500 text-white dark:bg-green-400 dark:border-green-400'
                  : menuIndexToTab(index) <= maxTab
                  ? 'bg-white border-gray-300 text-gray-700 dark:bg-slate-800 dark:border-slate-600 dark:text-gray-300 hover:border-primary dark:hover:border-blue-500'
                  : 'bg-gray-100 border-gray-200 text-gray-400 dark:bg-slate-900 dark:border-slate-800 dark:text-slate-600',
              ]"
            >
              <!-- Checkmark para etapas concluídas -->
              <svg
                v-if="menuIndexToTab(index) < tab"
                class="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path
                  fill-rule="evenodd"
                  d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                  clip-rule="evenodd"
                />
              </svg>
              <!-- Número para etapas atuais/futuras -->
              <span v-else class="text-sm font-semibold">{{ index + 1 }}</span>
            </div>

            <!-- Label -->
            <span
              class="text-xs text-center max-w-[120px] leading-tight transition-colors"
              :class="[
                tab === menuIndexToTab(index)
                  ? 'text-primary font-semibold dark:text-blue-400'
                  : menuIndexToTab(index) < tab
                  ? 'text-green-600 font-medium dark:text-green-400'
                  : menuIndexToTab(index) <= maxTab
                  ? 'text-gray-600 dark:text-gray-400'
                  : 'text-gray-400 dark:text-slate-600',
              ]"
            >
              {{ item }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <!-- Conteúdo Dinâmico -->
    <div
      class="bg-white dark:bg-slate-800 rounded-lg shadow-sm border border-gray-200 dark:border-slate-700 overflow-hidden"
    >
      <!-- Wrapper com padding controlado para não quebrar .row dos filhos -->
      <div class="p-4 sm:p-6">
        <div v-if="tab == 0">
          <DadosEmpresa
            v-if="informacoesEmpresa"
            ref="form_0"
            :Edicao="Edicao"
          />
        </div>
        <div v-if="tab == 1">
          <Procuradores :Edicao="Edicao" ref="form_1" />
        </div>
        <div v-if="tab == 2">
          <Representantes :Edicao="Edicao" ref="form_2" />
        </div>
        <div v-if="tab == 3">
          <DadosFinanceiros
            v-if="informacoesFinanceiras"
            ref="form_3"
            :informacoesFinanceiras="informacoesFinanceiras"
            :Edicao="Edicao"
          />
          <div v-if="!informacoesFinanceiras" class="loading-overlay">
            <div class="spinner"></div>
          </div>
        </div>
        <div v-if="tab == 4">
          <DadosBancarios v-if="infoBancarios" ref="form_4" :Edicao="Edicao" />
          <div v-if="!infoBancarios" class="loading-overlay">
            <div class="spinner"></div>
          </div>
        </div>
        <div v-if="tab == 5">
          <Endereco
            v-if="informacoesEndereco"
            ref="form_5"
            :informacoesEndereco="informacoesEndereco"
            :Edicao="Edicao"
          />
          <div v-if="!informacoesEndereco" class="loading-overlay">
            <div class="spinner"></div>
          </div>
        </div>
        <div v-if="tab == 6">
          <UploadDocumentos :Edicao="Edicao" ref="form_6" />
        </div>
        <div v-if="tab == 7">
          <Declaracoes
            v-if="informacoesDeclaracoes"
            ref="form_7"
            :informacoesDeclaracoes="informacoesDeclaracoes"
            :Edicao="Edicao"
          />
          <div v-if="!informacoesDeclaracoes" class="loading-overlay">
            <div class="spinner"></div>
          </div>
        </div>
        <div
          v-if="tab == 8 && user?.TipoCliente == TIPO_CLIENTE.PESSOA_JURIDICA"
        >
          <Produtos :Edicao="Edicao" :nomeAbaProdutos="nomeAbaProdutos" ref="form_8" />
        </div>
        <div v-if="tab == 8 && user?.TipoCliente == TIPO_CLIENTE.INSTITUCIONAL">
          <Produtos :Edicao="Edicao" :nomeAbaProdutos="nomeAbaProdutos" ref="form_8" />
        </div>
      </div>

      <!-- Footer Fixo -->
      <div
        class="sticky bottom-0 lg:static bg-white dark:bg-slate-800 border-t border-gray-200 dark:border-slate-700 px-4 sm:px-6 py-4"
      >
        <div class="flex flex-col sm:flex-row gap-3 sm:justify-between">
          <button
            @click="validarFormularioAtual"
            class="order-2 sm:order-1 px-6 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-200 bg-white dark:bg-slate-700 border border-gray-300 dark:border-slate-600 rounded-lg hover:bg-gray-50 dark:hover:bg-slate-600 transition-colors"
          >
            {{ Edicao ? "Salvar" : "Salvar e continuar depois" }}
          </button>

          <button
            v-if="!Edicao"
            @click="proximaEtapa"
            class="order-1 sm:order-2 px-6 py-2.5 text-sm font-medium text-white bg-primary dark:bg-blue-600 rounded-lg hover:bg-primary-dark dark:hover:bg-blue-700 transition-colors shadow-sm"
          >
            {{ tab == 8 ? "Concluir" : "Avançar" }}
          </button>
        </div>
      </div>
    </div>
  </div>

  <ModalAlterarSenha />
  <ModalAlerta
    :mostrar="modalAlerta.mostrar"
    :tipo="modalAlerta.tipo"
    :titulo="modalAlerta.titulo"
    :mensagem="modalAlerta.mensagem"
    @fechar="fecharModalAlerta"
  />
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { useTheme } from "@/composables/useTheme";
import DadosEmpresa from "./DadosEmpresa.vue";
import Representantes from "./Representantes.vue";
import Procuradores from "./Procuradores.vue";
import DadosFinanceiros from "./DadosFinanceiros.vue";
import DadosBancarios from "../Shared/DadosBancarios.vue";
import Endereco from "./Endereco.vue";
import UploadDocumentos from "./UploadDocumentos.vue";
import Declaracoes from "./Declaracoes.vue";
import Produtos from "./Produtos.vue";
import api from "@/api/axios";

import navigationTracker from "@/services/modules/userNavigationTracker";
import { TIPO_CLIENTE } from "@/constants/TipoClienteEnum";
import ModalAlterarSenha from "../AlterarSenha/ModalAlterarSenha.vue";
import ModalAlerta from "../Utilitarios/ModalAlerta.vue";
export default {
  components: {
    DadosEmpresa,
    Procuradores,
    Representantes,
    DadosFinanceiros,
    DadosBancarios,
    Endereco,
    UploadDocumentos,
    Declaracoes,
    Produtos,
    ModalAlterarSenha,
    ModalAlerta,
  },
  name: "CadastroPJ_Passo_1",
  props: ["Edicao", "BloquearSalvarIsolado"],

  setup() {
    const { isDark, toggleTheme } = useTheme();
    return { isDark, toggleTheme };
  },

  computed: {
    ...mapGetters({
      user: "auth/user",
      infoEmpresa: "GET_PJ_INFO_EMPRESA",
      infoComplementoEmpresa: "GET_PJ_INFO_COMPLEMENTO_EMPRESA",
      infoFinanceiras: "GET_PJ_INFO_FINANCEIRA_EMPRESA",
      infoBancarios: "GET_PJ_INFO_BANCARIOS",
      infoEndereco: "GET_PJ_INFO_ENDERECO",
      infoDeclaracoes: "GET_PJ_INFO_DECLARACOES",
      salvarInformacoesPJ: "GET_PJ_SALVAR_INFO",
      enviarCadastro: "GET_ENVIAR_CADASTRO",
      ObjSalvarInformacoesEmpresa: "GET_PJ_SALVAR_INFO_EMPRESA",
      ObjSalvarInformacoesComplementoEmpresa:
        "GET_PJ_SALVAR_INFO_COMPLEMENTO_EMPRESA",
      ObjSalvarInformacoesComplementoSocios:
        "GET_PJ_SALVAR_INFO_COMPLEMENTO_SOCIOS",
      ObjSalvarInformacoesFinanceiro: "GET_PJ_SALVAR_INFO_FINANCEIRO",
      ObjSalvarInformacoesBancarias: "GET_PJ_SALVAR_INFO_BANCARIAS",
      ObjSalvarInformacoesBancariasAdicional:
        "GET_PJ_SALVAR_INFO_BANCARIAS_ADICIONAL",
      ObjSalvarInformacoesEndereco: "GET_PJ_SALVAR_INFO_ENDERECO",
      ObjSalvarInformacoesDeclaracoes: "GET_PJ_SALVAR_INFO_DECLARACOES",
      ObjSalvarInformacoesUploadArquivos: "GET_SALVAR_INFO_UPLOAD",
      ObjSalvarQuestionario: "GET_SALVAR_QUESTIONARIO",
      salvarObjConcluir: "GET_FICHA_CONCLUIR",
      etapaCadastro: "GET_ETAPA_CADASTRO",
      etapasConcluidas: "GET_ETAPA_CONCLUIDA",
      salvarObjDispensaQuestionario: "GET_PF_PJ_SALVAR_INFO_DISPENSA",
      desabilitarNotificacao: "GET_SALVAR_INFO_DES_NOTIFICACAO",
      getConfiguracoes: "GET_CONFIGURACOES",
    }),
    salvouTodasAbas() {
      const { gravarDados } = this;
      return Object.values(gravarDados).every((value) => value === 1);
    },
    nomeMenu() {
      if (this.user?.TipoCliente == TIPO_CLIENTE.PESSOA_JURIDICA) {
        var menus = [
          "Dados da Empresa",
          "Procuradores",
          "Representantes",
          "Dados Financeiros",
          "Dados Bancários",
          "Endereço",
          "Upload de Documentos",
          "Declarações",
          this.nomeAbaProdutos,
        ];
        return menus[this.tab] || "Menu Desconhecido";
      } else {
        var menusInstitucional = [
          "Dados Institucional",
          "Procuradores",
          "Representantes",
          "Dados Financeiros",
          "Dados Bancários",
          "Endereço",
          "Upload de Documentos",
          "Declarações",
          "Enquadramento",
        ];
        return menusInstitucional[this.tab] || "Menu Desconhecido";
      }
    },
    menuItems() {
      if (this.user?.TipoCliente == TIPO_CLIENTE.PESSOA_JURIDICA) {
        var items = [
          "Dados da Empresa",
          "Procuradores",
          "Representantes",
          "Dados Financeiros",
          "Endereço",
          "Upload de Documentos",
          "Declarações",
          this.nomeAbaProdutos,
        ];

        if (this.nomeEmpresa != "GENIAL") {
          items.splice(4, 0, "Dados Bancários");
        }

        return items;
      } else {
        var itemsInstitucional = [
          "Dados Institucional",
          "Procuradores",
          "Representantes",
          "Dados Financeiros",
          "Endereço",
          "Upload de Documentos",
          "Declarações",
          "Enquadramento",
        ];

        if (this.nomeEmpresa != "GENIAL") {
          itemsInstitucional.splice(4, 0, "Dados Bancários");
        }

        return itemsInstitucional;
      }
    },
    tabToMenuIndex() {
      if (!this.nomeEmpresa) return this.tab;
      if (this.nomeEmpresa === "GENIAL" && this.tab >= 5) {
        return this.tab - 1;
      }
      return this.tab;
    },
    maxTabMenuIndex() {
      if (!this.nomeEmpresa) return this.maxTab;
      if (this.nomeEmpresa === "GENIAL" && this.maxTab >= 5) {
        return this.maxTab - 1;
      }
      return this.maxTab;
    },
  },
  data() {
    return {
      TIPO_CLIENTE,
      menuAberto: false,
      maxTab: 0,
      isLoading: true,
      color: "#3b8070",
      configuracaoToken: "n",
      nomeAbaProdutos: "Produtos",
      solicitouProximaEtapa: false,
      gravarDados: {
        salvarInformacoesPJ: 0,
        salvarComplementoEmpresa: 0,
        salvarComplementoSocios: 0,
        salvarDadosFinanceiro: 0,
        salvarDadosBancariosPrincipal: 0,
        salvarDadosBancariosAdicional: 0,
        salvarDadosEndereco: 0,
        salvarDadosDeclaracoes: 0,
        salvarInformacoesUpload: 0,
        salvarInformacoesDispensaQuestionario: 0,
        salvarQuestionario: 0,
      },
      nomeEmpresa: process.env.VUE_APP_NOME_EMPRESA || "",
      tab: 0,
      informacoesEmpresa: null,
      informacoesFinanceiras: this.infoFinanceiras,
      informacoesDeclaracoes: this.infoDeclaracoes,
      informacoesEndereco: null,
      modalAlerta: {
        mostrar: false,
        tipo: "success",
        titulo: "",
        mensagem: "",
        aoFechar: null,
      },
    };
  },
  created() {
    this.obterDados();
    this.$store.commit("SET_FICHA_CONCLUIR", false);
  },
  async mounted() {
    await this.fetchConfiguracao([
      "Modo de autenticação",
      "Obrigatoriedade Emissor de Ordem",
      "Campo Patrimônio liquido não aceita zero",
      "OnBoarding - Nomeclatura da aba de produto",
    ]);

    this.configuracaoToken =
      this.getConfiguracoes("Modo de autenticação")?.Valor != "2" ? "N" : "S";

    this.nomeAbaProdutos =
      this.getConfiguracoes("OnBoarding - Nomeclatura da aba de produto")
        ?.Valor ?? "Produtos";

    if (!this.Edicao) {
      this.$store.commit("SET_ETAPA_CADASTRO", 0);
      this.executaProximaEtapa();
    } else {
      this.tab = this.etapaCadastro;

      if (this.maxTab < this.tab) {
        this.maxTab = this.tab;
      }
    }

    if (this.infoEmpresa != null) this.informacoesEmpresa = this.infoEmpresa;

    if (this.infoFinanceiras != null)
      this.informacoesFinanceiras = this.infoFinanceiras;

    if (this.infoEndereco != null) this.informacoesEndereco = this.infoEndereco;

    if (this.infoDeclaracoes != null)
      this.informacoesDeclaracoes = this.infoDeclaracoes;

    // Inicializar SignalR antes do tracking
    await this.$store.dispatch("INIT_DECLARACAO_SIGNALR");

    if (this.user?.ClienteId) {
      navigationTracker.startTracking(
        this.user.ClienteId,
        TIPO_CLIENTE.PESSOA_JURIDICA,
        `cadastro_pj_${Date.now()}`,
      );
      navigationTracker.trackViewChange("cadastro");
      navigationTracker.trackStepChange(this.tab, {
        view: "cadastro",
        editing: this.Edicao,
        completedSteps: this.etapasConcluidas || [],
      });
    }
  },
  methods: {
    ...mapActions({
      fetchConfiguracao: "FETCH_CONFIGURACOES",
    }),
    async validarFormularioAtual() {
      const refName = `form_${this.tab}`;
      const componente = this.$refs[refName];
      if (await this.validaComponente(refName, componente)) {
        if (componente?.salvarInformacoes) {
          const sucesso = await componente.salvarInformacoes();
          if (sucesso !== false && refName === "form_6") {
            this.$store.commit("SET_ETAPA_CONCLUIDA", this.tab);
            this.$emit("update:Edicao", false);
          }
        } else if (this.BloquearSalvarIsolado) {
          this.$store.commit("SET_PJ_SALVAR_INFO", true);
        } else {
          this.$swal({
            icon: "success",
            title: "Alterações realizadas com sucesso!",
            text: "Dados informados foram salvos com sucesso.",
          });
        }
      }
    },
    async validaComponente(refName, componente) {
      if (refName == "form_1") {
        return true;
      }

      if (
        componente?.validarFormulario &&
        (await componente.validarFormulario(true))
      ) {
        return true;
      }

      return false;
    },
    async proximaEtapa() {
      const refName = `form_${this.tab}`;
      const componente = this.$refs[refName];
      if (componente?.proximaEtapa) {
        await componente.proximaEtapa();
      }
    },
    async obterDados() {
      await this.$store.dispatch("FETCH_PJ_INFO_EMPRESA");
      await this.$store.dispatch("FETCH_PJ_INFO_COMPLEMENTO_EMPRESA");
      await this.$store.dispatch("FETCH_PJ_INFO_COMPLEMENTO_SOCIOS");
      await this.$store.dispatch("FETCH_PJ_INFO_FINANCEIRA");
      await this.$store.dispatch("FETCH_PJ_INFO_BANCARIOS");
      await this.$store.dispatch("FETCH_PJ_INFO_ENDERECO");
      await this.$store.dispatch("FETCH_PJ_INFO_DECLARACOES");
      await this.$store.dispatch("FETCH_CONSULTA_BANCOS");
      await this.$store.dispatch("FETCH_CONSULTA_PAISES");
      await this.$store.dispatch("FETCH_CONSULTA_ATIVIDADES", "PJ");
      await this.$store.dispatch("FETCH_QUESTIONARIO_BUSCAR_QUESTOES");
      await this.$store.commit("SET_PJ_SALVAR_INFO_BANCARIAS", null);
      await this.$store.commit("SET_PJ_SALVAR_INFO_BANCARIAS_ADICIONAL", null);
      await this.$store.dispatch("FETCH_BUSCA_LISTA_MOTIVO_DISPENSA");
      await this.$store.dispatch("FETCH_CONSULTA_DISCLAIMER");
      await this.$store.dispatch("FETCH_CONSULTA_TIPOS_CLIENTES_PJ");
      await this.$store.dispatch("FETCH_CONSULTA_TIPOS_INVESTIDORES");
      await this.$store.dispatch("FETCH_CONSULTA_NATUREZA_JURIDICA");
    },
    formatarValorFinanceiro(valorString) {
      if (valorString === null || valorString === undefined) {
        return 0;
      }

      if (typeof valorString !== "string") {
        valorString = String(valorString);
      }

      const valorNumerico = parseFloat(
        valorString
          .replace(/\s/g, "") // remove todos os espaços (inclusive \u00A0)
          .replace("R$", "")
          .replace(/\./g, "")
          .replace(",", "."),
      );

      return isNaN(valorNumerico) ? 0 : valorNumerico;
    },
    menuIndexToTab(menuIndex) {
      if (!this.nomeEmpresa) return menuIndex;
      if (this.nomeEmpresa === "GENIAL" && menuIndex >= 4) {
        return menuIndex + 1;
      }
      return menuIndex;
    },
    async selectTab(menuIndex) {
      const tabSelected = this.menuIndexToTab(menuIndex);
      if (tabSelected < this.tab || tabSelected <= this.maxTab) {
        const refName = `form_${this.tab}`;
        const componente = this.$refs[refName];

        var formularioValido = false;

        if (componente?.validarFormulario && this.tab < tabSelected) {
          if (!(await componente.validarFormulario(true))) {
            return;
          } else {
            formularioValido = true;
          }
        } else {
          formularioValido = true;
        }

        if (formularioValido) {
          console.log("formulario válido PJ");

          this.tab = tabSelected;

          if (this.maxTab < this.tab) {
            this.maxTab = this.tab;
          }

          this.$store.commit("SET_ETAPA_CADASTRO", this.tab);
        }
      }
      this.menuAberto = false;
    },
    alterarSenha() {
      this.$store.commit("SET_ABRIR_ALTERAR_SENHA", true);
    },
    logoff() {
      this.$store.dispatch("auth/logout");
    },
    fecharModalAlerta() {
      if (
        this.modalAlerta.aoFechar &&
        typeof this.modalAlerta.aoFechar === "function"
      ) {
        this.modalAlerta.aoFechar();
      }
      this.modalAlerta = {
        mostrar: false,
        tipo: "success",
        titulo: "",
        mensagem: "",
        aoFechar: null,
      };
    },
    async salvarConcluir() {
      if (this.salvarInformacoesPJ == true && this.salvarObjConcluir == true) {
        this.$store.commit("SET_PJ_SALVAR_INFO", false);
        this.$store.commit("SET_FICHA_CONCLUIR", false);
        this.$store.commit("SET_ENVIAR_CADASTRO", false);

        const data = {
          RenovacaoCadastral: this.BloquearSalvarIsolado,
        };

        await api
          .post("/PessoaJuridica/ConcluirCadastro", data)
          .then(async (retorno) => {
            if (retorno.status == 200) {
              // Notificar conclusao via SignalR
              await navigationTracker.trackCadastroCompleted({
                renovacao: this.BloquearSalvarIsolado,
                completedSteps: this.etapasConcluidas || [],
              });

              if (this.user.StatusCadastro > 1) {
                this.modalAlerta = {
                  mostrar: true,
                  tipo: "warning",
                  titulo: "Cadastro atualizado",
                  mensagem:
                    "As informações serão revisadas pela equipe responsável e você poderá acompanhar essa revisão pelo status.",
                };

                this.user.StatusCadastro = 4;
                this.$store.commit("auth/SET_USER", this.user);
              } else {
                this.modalAlerta = {
                  mostrar: true,
                  tipo: "success",
                  titulo: "Cadastro enviado!",
                  mensagem: "Seu cadastro está em análise.",
                  aoFechar: () => this.logoff(),
                };
              }
            }
          })
          .catch((error) => {
            this.$store.commit("SET_PJ_SALVAR_INFO", false);
            this.modalAlerta = {
              mostrar: true,
              tipo: "error",
              titulo: "Dados informados inválidos.",
              mensagem: error.response.data.data[0],
            };
          });
      } else {
        this.$store.commit("SET_PJ_SALVAR_INFO", false);
        if (this.desabilitarNotificacao == true) {
          this.$store.commit("SET_SALVAR_INFO_DES_NOTIFICACAO", false);
        } else if (!this.Edicao) {
          this.$swal({
            icon: "success",
            title: "Alterações realizadas com sucesso!",
            text: "Dados informados foram salvos com sucesso.",
          });
        }
        this.obterDados();
      }
    },
    async salvarQuestionarioAsync() {
      if (this.salvarInformacoesPJ) {
        if (
          this.ObjSalvarQuestionario == null ||
          (this.tab <= 7 && !this.Edicao)
        ) {
          this.gravarDados.salvarQuestionario = 1;
          return;
        } else {
          await api
            .post("/suitability", this.ObjSalvarQuestionario)
            .then((retorno) => {
              if (retorno.status == 200) {
                this.$store.commit("SET_SALVAR_QUESTIONARIO", null);
                this.gravarDados.salvarQuestionario = 1;
                this.$store.commit("SET_MODAL_QUESTIONARIO", false);

                if (!this.BloquearSalvarIsolado && !this.Edicao) {
                  this.$alert({
                    icon: "success",
                    title: "Salvo com sucesso!",
                    text: "Seus dados foram salvos.",
                  });
                }

                this.$store.dispatch("FETCH_PERFIL_CLIENTE");

                if (this.Edicao) {
                  if (
                    this.user.StatusCadastro == 3 &&
                    !this.user.PermiteLoginEmRevisao
                  ) {
                    this.logoff();
                  } else {
                    this.user.StatusCadastro = 4;
                  }
                }
              } else {
                this.gravarDados.salvarQuestionario = 2;
              }
            })
            .catch((error) => {
              this.gravarDados.salvarQuestionario = 2;
              console.log(error);
              this.$swal({
                icon: "error",
                title: "Dados informados inválidos.",
                text: `${error.response.descricao}`,
              });
            });
        }
      }
    },
    async salvarInformacoesDispensaQuestionario() {
      if (this.salvarInformacoesPJ) {
        if (
          this.salvarObjDispensaQuestionario == null ||
          (!this.Edicao && this.tab <= 7)
        ) {
          this.gravarDados.salvarInformacoesDispensaQuestionario = 1;
          return;
        } else {
          await api
            .post(
              "/suitability/dispensa-questionario",
              this.salvarObjDispensaQuestionario,
            )
            .then((retorno) => {
              if (retorno.status == 200) {
                this.$store.commit("SET_PF_PJ_SALVAR_INFO_DISPENSA", null);
                this.$store.dispatch("FETCH_PERFIL_CLIENTE");

                this.gravarDados.salvarInformacoesDispensaQuestionario = 1;
                return;
              }
            })
            .catch((error) => {
              this.gravarDados.salvarInformacoesDispensaQuestionario = 2;
              this.$store.commit("SET_PF_SALVAR_INFO", false);
              this.$swal({
                icon: "error",
                title:
                  "Dados informados inválidos na aba Produtos, sessão Dispensa de Questionário.",
                text: `${error.response.data.data[0]}`,
              });
            });
        }
      }
    },
    async salvarInformacoesUpload() {
      if (!this.salvarInformacoesPJ) {
        return;
      }

      if (
        this.ObjSalvarInformacoesUploadArquivos == null ||
        (!this.Edicao && this.tab <= 5)
      ) {
        this.gravarDados.salvarInformacoesUpload = 1;
        return;
      } else {
        const data = {
          documentos: this.ObjSalvarInformacoesUploadArquivos,
        };
        await api
          .post("/cliente/documentos", data)
          .then((retorno) => {
            if (retorno.status == 200) {
              this.$store.dispatch(
                "FETCH_CONSULTA_LISTA_DOCUMENTOS_UPLOAD_REALIZADO",
              );
              this.gravarDados.salvarInformacoesUpload = 1;
              this.$store.commit("SET_SALVAR_INFO_UPLOAD", null);
            }
          })
          .catch((error) => {
            this.gravarDados.salvarInformacoesUpload = 2;
            this.$store.commit("SET_PJ_SALVAR_INFO", false);
            this.$swal({
              icon: "error",
              title: "Falha ao realizar upload de documentos",
              text: `${error.response.data.data[0]}`,
            });
          });
      }
    },
    async salvarDadosDeclaracoes() {
      if (!this.salvarInformacoesPJ) {
        return;
      }

      if (
        this.ObjSalvarInformacoesDeclaracoes == null ||
        (!this.Edicao && this.tab <= 6)
      ) {
        this.gravarDados.salvarDadosDeclaracoes = 1;
        return;
      } else {
        await api
          .post(
            "/PessoaJuridica/declaracoes",
            this.ObjSalvarInformacoesDeclaracoes,
          )
          .then((retorno) => {
            if (retorno.status == 200) {
              this.$store.commit("SET_PJ_SALVAR_INFO_DECLARACOES", null);
              this.gravarDados.salvarDadosDeclaracoes = 1;
            }
          })
          .catch((error) => {
            this.$store.commit("SET_PJ_SALVAR_INFO", false);
            this.gravarDados.salvarDadosDeclaracoes = 2;
            if (
              error.response.data.data[0] &&
              error.response.data.data[0].includes(
                "pergunta obrigatória não informada",
              )
            ) {
              const campo = error.response.data.data[0].split(":")[0].trim();

              this.$swal({
                icon: "warning",
                title: "Atenção: pergunta obrigatório não informada.",
                text: `'${campo}*'`,
              });
            } else {
              this.$swal({
                icon: "error",
                title: "Dados informados inválidos na aba Informações.",
                text: `${error.response.data.data[0]}`,
              });
            }
          });
      }
    },
    async salvarDadosEndereco() {
      if (!this.salvarInformacoesPJ) {
        return;
      }

      if (
        this.ObjSalvarInformacoesEndereco == null ||
        (!this.Edicao && this.tab <= 4)
      ) {
        this.gravarDados.salvarDadosEndereco = 1;
        return;
      } else {
        await api
          .post("/PessoaJuridica/endereco", this.ObjSalvarInformacoesEndereco)
          .then((retorno) => {
            if (retorno.status == 200) {
              this.$store.commit("SET_PJ_SALVAR_INFO_ENDERECO", null);
              this.gravarDados.salvarDadosEndereco = 1;
              return;
            }
          })
          .catch((error) => {
            this.gravarDados.salvarDadosEndereco = 2;
            this.$store.commit("SET_PJ_SALVAR_INFO", false);
            this.$swal({
              icon: "error",
              title: "Dados informados inválidos na aba Informações.",
              text: `${error.response.data.data[0]}`,
            });
          });
      }
    },
    async salvarDadosBancariosAdicional() {
      if (!this.salvarInformacoesPJ) {
        return;
      }

      if (
        this.ObjSalvarInformacoesBancariasAdicional == null ||
        (!this.Edicao && this.tab <= 3)
      ) {
        this.gravarDados.salvarDadosBancariosAdicional = 1;
      } else {
        await api
          .post(
            "/PessoaJuridica/dadosBancarios",
            this.ObjSalvarInformacoesBancariasAdicional,
          )
          .then((retorno) => {
            if (retorno.status == 200) {
              this.$store.commit(
                "SET_PJ_SALVAR_INFO_BANCARIAS_ADICIONAL",
                null,
              );
              this.gravarDados.salvarDadosBancariosAdicional = 1;
            }
          })
          .catch((error) => {
            this.$store.commit("SET_PJ_SALVAR_INFO", false);
            this.gravarDados.salvarDadosBancariosAdicional = 2;
            this.$swal({
              icon: "error",
              title: "Dados informados inválidos na aba Informações.",
              text: `${error.response.data.data[0]}`,
            });
          });
      }
    },
    async salvarDadosBancariosPrincipal() {
      if (!this.salvarInformacoesPJ) {
        return;
      }

      if (
        this.ObjSalvarInformacoesBancarias == null ||
        (!this.Edicao && this.tab <= 3)
      ) {
        this.gravarDados.salvarDadosBancariosPrincipal = 1;
        return;
      } else {
        await api
          .post(
            "/PessoaJuridica/dadosBancarios",
            this.ObjSalvarInformacoesBancarias,
          )
          .then((retorno) => {
            if (retorno.status == 200) {
              this.$store.commit("SET_PJ_SALVAR_INFO_BANCARIAS", null);
              this.gravarDados.salvarDadosBancariosPrincipal = 1;
            }
          })
          .catch((error) => {
            this.$store.commit("SET_PJ_SALVAR_INFO", false);
            this.gravarDados.salvarDadosBancariosPrincipal = 2;
            this.$swal({
              icon: "error",
              title: "Dados informados inválidos na aba Informações.",
              text: `${error.response.data.data[0]}`,
            });
          });
      }
    },
    async salvarDadosFinanceiro() {
      if (!this.salvarInformacoesPJ) {
        return;
      }

      if (
        this.ObjSalvarInformacoesFinanceiro == null ||
        (!this.Edicao && this.tab <= 2)
      ) {
        this.gravarDados.salvarDadosFinanceiro = 1;
        return;
      } else {
        const dadosFormatados = { ...this.ObjSalvarInformacoesFinanceiro };
        // Formata cada campo financeiro
        dadosFormatados.FaturamentoMedioMensal = this.formatarValorFinanceiro(
          dadosFormatados.FaturamentoMedioMensal,
        );
        dadosFormatados.CapitalSocial = this.formatarValorFinanceiro(
          dadosFormatados.CapitalSocial,
        );
        dadosFormatados.PatrimonioAplicacoesFinanceiras =
          this.formatarValorFinanceiro(
            dadosFormatados.PatrimonioAplicacoesFinanceiras,
          );
        dadosFormatados.PatrimonioLiquido = this.formatarValorFinanceiro(
          dadosFormatados.PatrimonioLiquido,
        );
        dadosFormatados.ValorBensMoveisImoveis = this.formatarValorFinanceiro(
          dadosFormatados.ValorBensMoveisImoveis,
        );
        await api
          .post("/PessoaJuridica/dadosFinanceiros", dadosFormatados)
          .then((retorno) => {
            if (retorno.status == 200) {
              this.$store.commit("SET_PJ_SALVAR_INFO_FINANCEIRO", null);
              this.gravarDados.salvarDadosFinanceiro = 1;
              return;
            }
          })
          .catch((error) => {
            this.gravarDados.salvarDadosFinanceiro = 2;
            this.$store.commit("SET_PJ_SALVAR_INFO", false);
            this.$swal({
              icon: "error",
              title: "Dados informados inválidos na aba Dados Financeiro",
              text: `${error.response.data.data[0]}`,
            });
          });
      }
    },
    async salvarComplementoSocios() {
      if (!this.salvarInformacoesPJ) {
        return;
      }

      if (this.ObjSalvarInformacoesComplementoSocios == null) {
        this.gravarDados.salvarComplementoSocios = 1;
        return;
      } else {
        var obj = { socios: this.ObjSalvarInformacoesComplementoSocios };
        await api
          .post("/PessoaJuridica/socios", obj)
          .then((retorno) => {
            if (retorno.status == 200) {
              this.$store.commit("SET_PJ_SALVAR_INFO_COMPLEMENTO_SOCIOS", null);
              this.$store.dispatch("FETCH_PJ_INFO_COMPLEMENTO_SOCIOS");
              this.gravarDados.salvarComplementoSocios = 1;
            }
          })
          .catch((error) => {
            this.gravarDados.salvarComplementoSocios = 2;
            this.$store.commit("SET_PJ_SALVAR_INFO", false);
            this.$swal({
              icon: "error",
              title: "Dados informados inválidos na aba Informações.",
              text: `${error.response.data.data[0]}`,
            });
          });
      }
    },
    async salvarComplementoEmpresa() {
      if (!this.salvarInformacoesPJ) {
        return;
      }

      if (this.ObjSalvarInformacoesComplementoEmpresa == null) {
        this.gravarDados.salvarComplementoEmpresa = 1;
        return;
      } else {
        var obj = { empresas: this.ObjSalvarInformacoesComplementoEmpresa };
        await api
          .post("/PessoaJuridica/empresas", obj)
          .then((retorno) => {
            if (retorno.status == 200) {
              this.$store.commit(
                "SET_PJ_SALVAR_INFO_COMPLEMENTO_EMPRESA",
                null,
              );
              this.gravarDados.salvarComplementoEmpresa = 1;
              return;
            }
          })
          .catch((error) => {
            this.$store.commit("SET_PJ_SALVAR_INFO", false);
            this.gravarDados.salvarComplementoEmpresa = 2;
            this.$swal({
              icon: "error",
              title:
                'Dados informados inválidos na aba Informações, em "Empresas coligadas, controladas ou controladoras"',
              text: `${error.response.data.data[0]}`,
            });
          });
      }
    },
    executaProximaEtapa() {
      this.tab = this.etapaCadastro;

      if (this.maxTab < this.tab) {
        this.maxTab = this.tab;
      }
    },
    async salvar() {
      this.salvarComplementoEmpresa();
      this.salvarComplementoSocios();
      this.salvarDadosFinanceiro();
      this.salvarDadosBancariosPrincipal();
      this.salvarDadosBancariosAdicional();
      this.salvarDadosEndereco();
      this.salvarInformacoesUpload();
      this.salvarDadosDeclaracoes();
      this.salvarInformacoesDispensaQuestionario();
      this.salvarQuestionarioAsync();
      if (this.ObjSalvarInformacoesEmpresa == null) {
        this.gravarDados.salvarInformacoesPJ = 1;
        return;
      } else {
        if (this.desabilitarNotificacao) {
          this.ObjSalvarInformacoesEmpresa.ProximoPasso = true;
        }

        await api
          .post(
            "/PessoaJuridica/informacaoBasica",
            this.ObjSalvarInformacoesEmpresa,
          )
          .then((retorno) => {
            if (retorno.status == 200) {
              this.$store.commit("SET_PJ_SALVAR_INFO_EMPRESA", null);
              this.gravarDados.salvarInformacoesPJ = 1;
              return;
            }
          })
          .catch((error) => {
            this.gravarDados.salvarInformacoesPJ = 2;
            this.$store.commit("SET_PJ_SALVAR_INFO", false);
            this.$swal({
              icon: "error",
              title: "Dados informados inválidos na aba Informações.",
              text: `${error.response.data.data[0]}`,
            });
          });
      }
    },
    async verificaSePassouPorTodosPassos() {
      this.$store.commit("SET_ETAPA_CONCLUIDA", this.tab);

      var etapasObrigatorias = [0, 1, 2, 3, 5, 6, 7, 8, 9];

      if (this.nomeEmpresa.toUpperCase() != "GENIAL") {
        etapasObrigatorias.push(4);
      }

      if (!Array.isArray(this.etapasConcluidas)) {
        return false;
      }

      const etapasConcluidas = Array.isArray(this.etapasConcluidas)
        ? this.etapasConcluidas.filter((e) => typeof e === "number")
        : [];

      const todasEtapasOk = etapasObrigatorias.every((etapa) =>
        etapasConcluidas.includes(etapa),
      );

      if (todasEtapasOk) {
        return true;
      } else {
        this.$store.commit("SET_ETAPA_CONCLUIDA", this.tab);
        return false;
      }
    },
  },
  watch: {
    tab(newTab, oldTab) {
      if (newTab !== oldTab && this.user?.ClienteId) {
        navigationTracker.trackStepChange(newTab, {
          view: "cadastro",
          editing: this.Edicao,
          completedSteps: Array.isArray(this.etapasConcluidas)
            ? [...this.etapasConcluidas]
            : [],
        });
      }
    },
    salvouTodasAbas(newVal) {
      if (newVal) {
        this.salvarConcluir();
        if (this.solicitouProximaEtapa) {
          this.executaProximaEtapa();
          this.$store.commit("SET_PJ_SALVAR_INFO", false);
        } else if (this.enviarCadastro) {
          this.salvarConcluir();
        }
        this.gravarDados.salvarInformacoesPJ = 0;
        this.gravarDados.salvarComplementoEmpresa = 0;
        this.gravarDados.salvarComplementoSocios = 0;
        this.gravarDados.salvarDadosFinanceiro = 0;
        this.gravarDados.salvarDadosBancariosPrincipal = 0;
        this.gravarDados.salvarDadosBancariosAdicional = 0;
        this.gravarDados.salvarDadosEndereco = 0;
        this.gravarDados.salvarDadosDeclaracoes = 0;
        this.gravarDados.salvarInformacoesUpload = 0;
        this.gravarDados.salvarInformacoesDispensaQuestionario = 0;
        this.gravarDados.salvarQuestionario = 0;
      }
    },
    etapaCadastro() {
      if (this.isInitialLoad) {
        // Durante carga inicial (mount/reload), não executa nada
        return;
      }

      if (this.navegacaoManual) {
        // Navegação manual via menu - não avança automaticamente
        this.navegacaoManual = false;
        return;
      }

      if (this.Edicao) {
        this.tab = this.etapaCadastro;
      } else if (this.etapaCadastro == 0) {
        this.executaProximaEtapa();
      } else {
        this.solicitouProximaEtapa = true;
      }
    },
    infoEndereco() {
      this.informacoesEndereco = this.infoEndereco;
    },
    infoEmpresa() {
      this.informacoesEmpresa = this.infoEmpresa;
    },
    infoFinanceiras() {
      this.informacoesFinanceiras = this.infoFinanceiras;
    },
    infoDeclaracoes() {
      this.informacoesDeclaracoes = this.infoDeclaracoes;
    },
    enviarCadastro() {
      if (this.enviarCadastro) {
        this.$store.commit("SET_PJ_SALVAR_INFO", true);
      }
    },
    async salvarInformacoesPJ() {
      if (this.salvarInformacoesPJ) {
        if (this.BloquearSalvarIsolado) {
          this.$store.commit("SET_MODAL_QUESTIONARIO", false);
          this.$emit("update:Edicao", false);

          if (
            (await this.verificaSePassouPorTodosPassos()) == false ||
            !this.enviarCadastro
          ) {
            this.$store.commit("SET_PJ_SALVAR_INFO", false);
            this.$store.commit("SET_ENVIAR_CADASTRO", false);
            return;
          }
          this.$store.commit("SET_ENVIAR_CADASTRO", false);
          this.$store.commit("SET_FICHA_CONCLUIR", true);
        } else if (
          this.Edicao &&
          !this.BloquearSalvarIsolado &&
          !this.enviarCadastro
        ) {
          this.$store.commit("SET_PJ_SALVAR_INFO", false);
          this.$store.commit("SET_ENVIAR_CADASTRO", false);
          this.$store.commit("SET_MODAL_AVISO", "ModalConfirmar");
          this.$emit("update:Edicao", false);
          this.$store.commit("SET_FICHA_CONCLUIR", true);
          return;
        }

        this.salvar();
      }
    },
  },
};
</script>

<style scoped>
/* Animações de transição para sidebar mobile */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}

.slide-enter-from,
.slide-leave-to {
  transform: translateX(-100%);
}
</style>
